// =========================================================
// * Vuetify Material Dashboard - v2.1.0
// =========================================================
//
// * Product Page: https://www.creative-tim.com/product/vuetify-material-dashboard
// * Copyright 2019 Creative Tim (https://www.creative-tim.com)
//
// * Coded by Creative Tim
//
// =========================================================
//
// * The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

import Vue from 'vue'
import App from './App.vue'
import router from './router/index'
import { routes as ezRoutes } from './router/ezwave'
import { routes as vwRoutes } from './router/velociter'
import { routes as staffRoutes } from './router/staff'
import store from './store/index'
import './plugins/base'
import './plugins/chartist'
import './plugins/vee-validate'
import vuetify from './plugins/vuetify'
import i18n from './i18n'
import PerfectScrollbar from 'vue2-perfect-scrollbar'
import interceptorsSetup from './helpers/axinstance'
import * as VueGoogleMaps from 'vue2-google-maps'
import VueSocketIO from 'vue-socket.io'
import ApiService from '@/services/api.service'
import './registerServiceWorker'
// import * as socketIoClient from 'socket.io-client'

ApiService.init()
Vue.config.productionTip = false
Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyCbOQOR-PSwAIVuoRakiqznF4eIAn8AXb0',
    libraries: 'places,drawing,visualization',
    // libraries: 'places', // This is required if you use the Autocomplete plugin
    // OR: libraries: 'places,drawing'
    // OR: libraries: 'places,drawing,visualization'
    // (as you require)

    /// / If you want to set the version, you can do so:
    // v: '3.26',
  },

  /// / If you intend to programmatically custom event listener code
  /// / (e.g. `this.$refs.gmap.$on('zoom_changed', someFunc)`)
  /// / instead of going through Vue templates (e.g. `<GmapMap @zoom_changed="someFunc">`)
  /// / you might need to turn this on.
  // autobindAllEvents: false,

  /// / If you want to manually install components, e.g.
  /// / import {GmapMarker} from 'vue2-google-maps/src/components/marker'
  /// / Vue.component('GmapMarker', GmapMarker)
  /// / then set installComponents to 'false'.
  /// / If you want to automatically install all the components this property must be set to 'true':
  installComponents: true,
})

Vue.use(new VueSocketIO({
  debug: true,
  // connection: socketIoClient(process.env.VUE_APP_API_URL, options),
  connection: process.env.VUE_APP_API_URL,
  vuex: {
    store,
    actionPrefix: 'SOCKET_',
    mutationPrefix: 'SOCKET_',
  },
  options: {
    path: '/engine.io',
    transports: ['websocket'],
  },

}))
Vue.use(PerfectScrollbar)

// importing the helper
// and running it somewhere here
interceptorsSetup()

router.addRoutes(staffRoutes)
switch (process.env.VUE_APP_STORE_NAME) {
  case 'ezwave':
    router.addRoutes(ezRoutes)
    break
  case 'velociter':
    router.addRoutes(vwRoutes)
    break
}

new Vue({
  router,
  store,
  vuetify,
  i18n,
  render: h => h(App),
}).$mount('#app')
